var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.5 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1.5c1.12 0 2.067-.736 2.386-1.75h1.364a.75.75 0 0 0 0-1.5h-1.364a2.501 2.501 0 0 0-4.771 0H5.75a.75.75 0 0 0 0 1.5h6.365A2.501 2.501 0 0 0 14.5 11Zm-7.386 3.75H5.75a.75.75 0 0 0 0 1.5h1.364a2.501 2.501 0 0 0 4.772 0h6.364a.75.75 0 0 0 0-1.5h-6.364a2.501 2.501 0 0 0-4.772 0Zm1.386.75a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSettings;